module.exports = __webpack_public_path__ + "static/media/HouseSmartVideoBudgetSmart.774b7889.jpg";